/**
 * Mattermost Measurement Icon Replacer
 * Replaces tooltip icons next to Door Width, Door Height, Door Depth, and Jamb Depth fields
 * with a measuring tape icon for better UX clarity.
 */

(function () {
  'use strict';

  // Field names that should get the measuring tape icon
  const MEASUREMENT_FIELDS = [
    'Door Width',
    'Door Height',
    'Door Depth',
    'Jamb Depth',
  ];

  // Get SVG from the rendered Liquid snippet once
  const iconTemplate = document.querySelector(
    '#icon-measuring-tape-template svg'
  );

  if (!iconTemplate) {
    console.error(
      'Mattermost Icons: Measuring tape icon template not found in the DOM.'
    );
    return;
  }

  const MEASURING_TAPE_HTML = iconTemplate.innerHTML;
  const MEASURING_TAPE_VIEWBOX = iconTemplate.getAttribute('viewBox');

  /**
   * Replaces help icons with measuring tape icons for measurement fields
   */
  function replaceMeasurementIcons() {
    // Find all labels in the Mattermost form
    const labels = document.querySelectorAll('.mw-label');

    labels.forEach((label) => {
      const labelText = label.textContent.trim();

      // Check if this label is for a measurement field
      const isMeasurementField = MEASUREMENT_FIELDS.some((field) =>
        labelText.includes(field)
      );

      if (isMeasurementField) {
        // Find the tooltip icon SVG within this label
        const svg = label.querySelector('.mw-tooltip--icon svg');

        if (svg && !svg.dataset.iconReplaced) {
          // Replace the SVG content with measuring tape icon from template
          svg.innerHTML = MEASURING_TAPE_HTML;
          svg.setAttribute('viewBox', MEASURING_TAPE_VIEWBOX);

          // Make the icon bigger - use !important to override any theme CSS
          svg.setAttribute('width', '24');
          svg.setAttribute('height', '24');
          svg.style.setProperty('width', '24px', 'important');
          svg.style.setProperty('height', '24px', 'important');
          svg.style.setProperty('min-width', '24px', 'important');
          svg.style.setProperty('flex-shrink', '0', 'important');
          svg.style.verticalAlign = 'middle';
          svg.style.display = 'inline-block';

          // Mark as replaced to avoid duplicate processing
          svg.dataset.iconReplaced = 'true';

          // Add a class for potential additional styling
          const iconContainer = svg.closest('.mw-tooltip--icon');
          if (iconContainer) {
            iconContainer.classList.add('mw-tooltip--measurement');

            // Make the icon container display inline to keep everything on one line
            iconContainer.style.display = 'inline-flex';
            iconContainer.style.alignItems = 'center';
            iconContainer.style.gap = '8px';

            // Add "how to measure" text if it doesn't already exist
            if (!iconContainer.querySelector('.measurement-help-text')) {
              const helpText = document.createElement('span');
              helpText.className = 'measurement-help-text';
              helpText.textContent = 'how to measure';
              helpText.style.fontSize = '16px';
              helpText.style.color = '#666';
              helpText.style.fontWeight = 'normal';
              helpText.style.cursor = 'pointer';
              helpText.style.whiteSpace = 'nowrap';

              // Insert the text after the icon
              iconContainer.appendChild(helpText);
            }
          }
        }
      }
    });
  }

  /**
   * Initialize icon replacement with multiple triggers
   * to handle dynamic form loading
   */
  function init() {
    // Run immediately if DOM is already loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', replaceMeasurementIcons);
    } else {
      replaceMeasurementIcons();
    }

    // Set up a MutationObserver to catch any future DOM changes
    // (in case the form loads via AJAX)
    const observer = new MutationObserver((mutations) => {
      let shouldReplace = false;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Element node
            if (node.classList && node.classList.contains('mw-label')) {
              shouldReplace = true;
            } else if (node.querySelector && node.querySelector('.mw-label')) {
              shouldReplace = true;
            }
          }
        });
      });

      if (shouldReplace) {
        replaceMeasurementIcons();
        observer.disconnect();
      }
    });

    // Start observing the document for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Initialize when script loads
  init();
})();
